import { render, staticRenderFns } from "./categoryIng-table.vue?vue&type=template&id=566b759d&"
import script from "./categoryIng-table.vue?vue&type=script&lang=js&"
export * from "./categoryIng-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports